import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getUserInfo } from '_utils/localData'
import { GROUP_IS_HOST, GROUP_IS_ADMIN } from '_utils/constant'

export default function useSelectGroup() {
  const history = useHistory()
  const groupIdFromUrl = new URLSearchParams(history.location.search).get('groupId')

  const [selectedGroup, setSelectedGroup] = useState(null)
  const reduxGroups = useSelector((state) => state.group?.myGroups)
  const groupById = useSelector((state) => state.group?.groupById)
  const userInfo = getUserInfo() || {}
  const groupsList = reduxGroups || userInfo?.groups || []

  const groupOptions = useMemo(() => {
    const validGroups = groupsList.filter(
      (item) => item.isHost === GROUP_IS_HOST || item.isAdmin === GROUP_IS_ADMIN
    )

    const options = validGroups.map((group) => ({
      value: group.gid || group.id,
      label: group.name,
    }))

    if (groupIdFromUrl && !options.some((g) => String(g.value) === String(groupIdFromUrl))) {
      const match = groupsList.find((g) => String(g.gid || g.id) === String(groupIdFromUrl))
      if (match) {
        options.push({
          value: match.gid || match.id,
          label: match.name,
        })
      } else if (groupById && String(groupById.id || groupById.gid) === String(groupIdFromUrl)) {
        options.push({
          value: groupById.id || groupById.gid,
          label: groupById.name || groupById.groupName || 'Selected Group',
        })
      }
    }

    return options
  }, [groupsList, groupIdFromUrl, groupById])

  useEffect(() => {
    if (groupOptions.length > 0) {
      if (groupIdFromUrl) {
        const found = groupOptions.find((g) => String(g.value) === String(groupIdFromUrl))
        if (found) {
          setSelectedGroup(found)
          return
        }
      }
      if (!selectedGroup) {
        setSelectedGroup(groupOptions[0])
      }
    }
  }, [groupOptions, groupIdFromUrl])

  const isGroupDisabled = Boolean(groupIdFromUrl)

  return {
    groupOptions,
    selectedGroup,
    setSelectedGroup,
    isGroupDisabled,
  }
}
